import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import { userAtom } from "../../../jotai/atoms";
import { formatNumber } from "../../../utils/data";
import VerifyPhone from "../../onboarding/VerifyPhone";
import EnterPhonePin from "../../onboarding/EnterPhonePin";

export function ContactPhoneCard() {
  const { t } = useTranslation();
  const [user] = useAtom(userAtom);
  const [verifyStep, setVerifyStep] = useState(true);

  return (
    <div className="card bg-base-100 max-md:rounded-none">
      <div className="bg-secondary text-secondary-content px-4 py-3 rounded-t-[var(--radius-box)] max-md:rounded-none">
        <h2 className="text-xl font-bold">{t("settings.update_contact_phone_number")}</h2>
      </div>
      <div className="card-body">
        <div className="flex flex-col gap-2">
          {user?.verified_phone_number && (
            <p className="font-bold">
              {t("settings.current_phone_number", {
                phoneNumber: formatNumber(user?.verified_phone_number ?? ""),
              })}
            </p>
          )}
          <div>
            {verifyStep && <VerifyPhone afterSubmit={() => setVerifyStep(false)} />}
            {!verifyStep && <EnterPhonePin />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPhoneCard;
